<script lang="ts">
    import {t} from "i18next";
    import {staticRoot} from "@src/appStore";
    import {onMount} from "svelte";

    export const iosAppStoreImageIsoCodes = [
        "ar", "az", "bg", "cn-SC", "cn-TC", "cz", "de", "dk", "ee", "en", "es-MX", "es", "fi",
        "fr-CA", "fr", "gr", "hu", "id", "il", "in", "it", "jp", "kr", "lt", "lv", "mt",
        "my", "nl", "no", "ph", "pl", "pt-BR", "pt-PR", "ro", "ru", "se", "si", "sk",
        "th", "tr", "vn"
    ];
    let langCode: string | undefined;

    onMount(() => {
        langCode = (() => {
            const browserLang = document.documentElement.lang;
            // There is a direct match
            if (browserLang in iosAppStoreImageIsoCodes) {
                return browserLang;
            }
            // Try to match primary code
            let primary = browserLang.slice(0, 2);
            if (primary.length !== 2) {
                throw new Error(`iOS app store badge translation lookup error. Expected ${primary} to be two characters.`);
            }
            // Iterate through the list and find the first matching code
            for (const code of iosAppStoreImageIsoCodes) {
                if (code.startsWith(primary)) {
                    return code;
                }
            }
            // Fall back to English if all else fails
            return "en";
        })();
    });


</script>

{#if langCode}
    <a href="#">
        <img src={`${$staticRoot}/images/app-store/ios/black/badge-${langCode}.svg`}
             alt={t("ios_app_alt_tag")}
             height={40}
             width={119.66}
        >
    </a>
{/if}